import { render, staticRenderFns } from "./sponsorsList.vue?vue&type=template&id=5871665e&scoped=true&"
import script from "./sponsorsList.vue?vue&type=script&lang=js&"
export * from "./sponsorsList.vue?vue&type=script&lang=js&"
import style0 from "./sponsorsList.vue?vue&type=style&index=0&id=5871665e&prod&lang=scss&scoped=true&"
import style1 from "./sponsorsList.vue?vue&type=style&index=1&id=5871665e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871665e",
  null
  
)

export default component.exports